// datetimepicker
$.datetimepicker.setLocale('ja');
$('input.js-datetime-picker').datetimepicker({
  format: 'Y-m-d H:i',
  closeOnDateSelect: true,
  scrollMonth: false,
});

$(document).ready(function() {
  function setElementHeight() {
    var viewportHeight = $(window).height();
    $('#app').css('height', viewportHeight);
  }

  // Call the function on page load and window resize
  $(window).on('load resize', setElementHeight);
});

$(function () {
  $.ajaxSetup({
    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
  });

  $('.js-back').on('click', function () {
    window.history.back();
  });

  $('input').on('keypress', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      $(this).blur();
    }
  });
});
